import React from 'react';

const SocialLinks = () => {

	const settings = JSON.parse( localStorage.getItem( 'settings' ) );

	return (   
		<ul className="social-icons flex-row flex-wrap justify-content-center">
			<li className="social-icons-facebook">
				<a href={ settings && settings.facebook } target="_blank" rel="noopener noreferrer" title="Facebook">
					fb.
				</a>
			</li>
			<li className="social-icons-twitter">
				<a href={ settings && settings.twitter } target="_blank" rel="noopener noreferrer" title="Twitter">
					tw.
				</a>
			</li>
			<li className="social-icons-linkedin">
				<a href={ settings && settings.linkedin } target="_blank" rel="noopener noreferrer" title="Linked In">
					li.
				</a>
			</li>
			<li className="social-icons-instagram">
				<a href={ settings && settings.instagram } target="_blank" rel="noopener noreferrer" title="Instagram">
					ig.
				</a>
			</li>
			<li className="social-icons-whatsapp">
				<a href={ settings && settings.whatsapp } target="_blank" rel="noopener noreferrer" title="WhatsApp">
					wa.
				</a>
			</li>
			<li className="social-icons-salesforce">
				<a href={ settings && settings.salesforce } target="_blank" rel="noopener noreferrer" title="SalesForce">
					sf.
				</a>
			</li>
		</ul>	
	)
}

export default SocialLinks